// The way through when the form cannot work.
//
// For seventeen days this site's contact form told every visitor to "complete
// the verification" on a page that had no verification on it. That is not a
// broken form, it is a DEAD END: a motivated customer had no way through and no
// way to know why. Nobody found out until the client asked for an unrelated
// edit.
//
// The form will break again — if not the verification widget then an expired
// mail key, a thrown Function, a DNS change, something nobody has thought of.
// This is what bounds the damage when it does. It is the difference between
// "lost seventeen days of leads" and "lost seventeen days of FORM leads while
// the phone still worked".
//
// TWO RULES, and they are the whole component:
//   1. Never present an instruction the page makes impossible to satisfy.
//   2. When the form cannot work, show a way to reach a human instead.

// Only routes that actually reach a person belong here. 555-010-0100 was a
// placeholder nobody answers, and offering it would have been the same dead end
// in a different shape — so the fallback is the email address alone until there
// is a phone number that rings.
export const REACH_US = {
  phone: '',
  email: 'troy@onemoreturnventures.com',
};

export default function ReachUs({ reason }: { reason?: string }) {
  const hasPhone = Boolean(REACH_US.phone);
  const hasEmail = Boolean(REACH_US.email);
  if (!hasPhone && !hasEmail) return null;

  return (
    <div
      role="alert"
      className="rounded-lg border border-amber-300 bg-amber-50 p-4 text-sm text-amber-900"
    >
      <p className="font-semibold">
        {reason || 'The form is not working at the moment.'}
      </p>
      <p className="mt-1">
        Sorry about that — please reach us directly and we will get straight back
        to you:
      </p>
      <ul className="mt-2 space-y-1">
        {hasPhone && (
          <li>
            <a className="font-semibold underline" href={`tel:${REACH_US.phone.replace(/[^+0-9]/g, '')}`}>
              {REACH_US.phone}
            </a>
          </li>
        )}
        {hasEmail && (
          <li>
            <a className="font-semibold underline" href={`mailto:${REACH_US.email}`}>
              {REACH_US.email}
            </a>
          </li>
        )}
      </ul>
    </div>
  );
}
